import { OneDecimalPlace } from '../../../helpers/Helpers';

export const totalWeeksOfSelectedQuarter = (rowArr, quarterIdx: number): number => {
  return rowArr[0].quarters[quarterIdx].months.length + 1;
};

export const calculateGrandTotal = (rowArr, type: string) => {
  const total = rowArr.reduce((rInit, row) => {
    rInit += row.quarters
      .reduce((qInit, quarter) => {
        qInit += quarter.months.reduce((mInit, month) => {
          mInit += month[type === 'Units' ? 'unit_value' : 'revenue_value'];
          return mInit;
        }, 0);
        return qInit;
      }, 0);
    return rInit;
  }, 0);

  return type === 'Units' ? Math.round(total) : OneDecimalPlace(total);
};

export const calculateGrandTotalComparision = (rowArr, type: string, comparisionType: string) => {
  if (comparisionType === '') {
    return 0;
  }

  const total = rowArr.reduce((rInit, row) => {
    rInit += row.quarters
      .filter((quarter) => !quarter.isPast)
      .reduce((qInit, quarter) => {
        qInit += quarter.months.reduce((mInit, month) => {
          mInit += month[type === 'Units' ? `unit_${comparisionType}` : `revenue_${comparisionType}`];
          return mInit;
        }, 0);
        return qInit;
      }, 0);
    return rInit;
  }, 0);

  return type === 'Units' ? Math.round(total) : OneDecimalPlace(total);
};

export const calculateProductGrandTotal = (quarterArr, type: string) => {
  const total = quarterArr
  //.filter((quarter) => !quarter.isPast)
    .reduce((acc, quarter) => {
      acc += quarter.months.reduce((init, month) => {
        init += month[type === 'Units' ? 'unit_value' : 'revenue_value'];
        return init;
      }, 0);
      return acc;
    }, 0);

  return type === 'Units' ? Math.round(total) : OneDecimalPlace(total);
};

export const calculateProductGrandTotalComparision = (quarterArr, type: string, comparisionType: string) => {
  if (comparisionType === '') {
    return 0;
  }

  const total = quarterArr
    .filter((quarter) => !quarter.isPast)
    .reduce((acc, quarter) => {
      acc += quarter.months.reduce((init, month) => {
        init += month[type === 'Units' ? `unit_${comparisionType}` : `revenue_${comparisionType}`];
        return init;
      }, 0);
      return acc;
    }, 0);

  return type === 'Units' ? Math.round(total) : OneDecimalPlace(total);
};

export const calculateQuarterTotal = (weekArr, type: string) => {
  const total = weekArr.reduce((acc, month) => {
    acc += month[type === 'Units' ? 'unit_value' : 'revenue_value'];
    return acc;
  }, 0);

  return type === 'Units' ? Math.round(total) : OneDecimalPlace(total);
};

export const calculateQuarterTotalComparision = (weekArr, type: string, comparisionType: string) => {
  const total = weekArr.reduce((acc, month) => {
    acc += month[type === 'Units' ? `unit_${comparisionType}` : `revenue_${comparisionType}`];
    return acc;
  }, 0);

  return type === 'Units' ? Math.round(total) : OneDecimalPlace(total);
};

export const calculateVerticalTotal = (rowArr, type: string) => {
  const total = rowArr.reduce((rInit, row) => {
    rInit += row.value;
    return rInit;
  }, 0);

  return type === 'Units' ? Math.round(total) : OneDecimalPlace(total);
};

export const calculateVerticalQuarterTotal = (rowArr, quarterIdx: number, type: string) => {
  const total = rowArr.reduce((acc, row) => {
    acc += row.quarters[quarterIdx].months.reduce((init, month) => {
      init += month[type === 'Units' ? 'unit_value' : 'revenue_value'];
      return init;
    }, 0);
    return acc;
  }, 0);

  return type === 'Units' ? Math.round(total) : OneDecimalPlace(total);
};

export const calculateVerticalQuarterTotalComparision = (rowArr, quarterIdx: number, type: string, comparisionType: string) => {
  const total = rowArr.reduce((acc, row) => {
    acc += row.quarters[quarterIdx].months.reduce((init, month) => {
      init += month[type === 'Units' ? `unit_${comparisionType}` : `revenue_${comparisionType}`];
      return init;
    }, 0);
    return acc;
  }, 0);

  return type === 'Units' ? Math.round(total) : OneDecimalPlace(total);
};

export const calculateVerticalWeekTotal = (rowArr, quarterIdx: number, weekIdx: number, type: string) => {
  const total = rowArr.reduce((acc, row) => {
    acc += row.quarters[quarterIdx].months[weekIdx]
      ? row.quarters[quarterIdx].months[weekIdx][type === 'Units' ? 'unit_value' : 'revenue_value']
      : 0;
    return acc;
  }, 0);

  return type === 'Units' ? Math.round(total) : OneDecimalPlace(total);
};

export const calculateVerticalWeekTotalComparision = (rowArr, quarterIdx: number, weekIdx: number, type: string, comparisionType: string) => {
  const total = rowArr.reduce((acc, row) => {
    acc += row.quarters[quarterIdx].months[weekIdx]
      ? row.quarters[quarterIdx].months[weekIdx][type === 'Units' ? `unit_${comparisionType}` : `revenue_${comparisionType}`]
      : 0;
    return acc;
  }, 0);

  return type === 'Units' ? Math.round(total) : OneDecimalPlace(total);
};

export const calculatePercentageValue = (value: number, total: number) => {
  return parseFloat(OneDecimalPlace((value / total) * 100).toString()) || 0;
};

export const calculateHorizontalQuarterPct = (rowArr, rowIdx) => {
  return rowArr[rowIdx].quarters.reduce((acc, quarter) => {
    acc += quarter.pctValue;
    return acc;
  }, 0);
};

export const calculateVerticalTotalPct = (rowArr) => {
  return rowArr.reduce((acc, row) => {
    acc += row.pctValue;
    return acc;
  }, 0);
};

export const calculateVerticalQuarterPct = (rowArr, quarterIdx) => {
  return rowArr.reduce((acc, row) => {
    acc += row.quarters[quarterIdx].pctValue;
    return acc;
  }, 0);
};

export const calculateVerticalWeekPct = (rowArr, quarterIdx: number, weekIdx: number): number => {
  return rowArr.reduce((acc, row) => {
    acc += row.quarters[quarterIdx].months[weekIdx] ? row.quarters[quarterIdx].months[weekIdx].pctValue : 0;
    return acc;
  }, 0);
};

export const calculateQuarterPct = (rowArr, rowIdx: number, quarterIdx: number): number => {
  return rowArr[rowIdx].quarters[quarterIdx].months.reduce((acc, month) => {
    acc += month.pctValue;
    return acc;
  }, 0);
};

export const calculateTotalVerticalEdit = (rowArr): number => {
  const total = rowArr
    .filter((row) => row.isEdited)
    .reduce((acc, row) => {
      acc += row.pctValue;
      return acc;
    }, 0);

  return OneDecimalPlace(total);
};

export const calculateTotalVerticalQuarterEdit = (rowArr, quarterIdx: number): number => {
  const total = rowArr.reduce((acc, row) => {
    acc += row.quarters[quarterIdx].isEdited ? row.quarters[quarterIdx].pctValue : 0;
    return acc;
  }, 0);

  return OneDecimalPlace(total);
};

export const calculateTotalVerticalWeekEdit = (rowArr, quarterIdx: number, weekIdx: number): number => {
  const total = rowArr.reduce((acc, row) => {
    acc += row.quarters[quarterIdx].months[weekIdx]
      ? (row.quarters[quarterIdx].months[weekIdx].isEdited ? row.quarters[quarterIdx].months[weekIdx].pctValue : 0)
      : 0;
    return acc;
  }, 0);

  return OneDecimalPlace(total);
};

export const calculateTotalHorizontalQuarterEdit = (rowArr, rIdx: number) => {
  const total = rowArr[rIdx].quarters
    .filter((quarter) => !quarter.isPast)
    .reduce((qInit, quarter) => {
      qInit += quarter.isEdited ? quarter.pctValue : 0;
      return qInit;
    }, 0);

  return OneDecimalPlace(total);
};

export const calculateTotalHorizontalWeekEdit = (rowArr, rIdx: number) => {
  const total = rowArr[rIdx].quarters
    .reduce((qInit, quarter) => {
      qInit += quarter.months.reduce((mInit, month) => {
        mInit += month.isEdited ? month.pctValue : 0;
        return mInit;
      }, 0);
      return qInit;
    }, 0);

  return OneDecimalPlace(total);
};

export const calculateHorizontalPrevValue = (quarters, type: string): number => {
  const total = quarters
    .filter((quarter) => !quarter.isPast)
    .reduce((acc, value) => {
      acc += value.oldValue;
      return acc;
    }, 0);

  return type === 'Units' ? Math.round(total) : OneDecimalPlace(total);
};
